import React, { useState, useEffect } from 'react';
import '../static/css/CameraList.css'
import { List, Row, Col, Modal, message, Button } from 'antd';
import axios from 'axios'
import servicePath from '../config/apiUrl'


const { confirm } = Modal;

function SurfSpotGeoList(props) {
  const [list, setList] = useState([])

  const getList = () => {
    const key = 'getList';
    message.loading({ content: '加载数据...', key });
    axios({
      method: 'get',
      url: servicePath.getSurfSpotGeoList,
    }).then(res => {
      if (res.data.code == 1) {
        setList(res.data.list)
        message.success({ content: '加载数据成功！', key, duration: 2 });
      } else {
        message.error({ content: '加载数据失败！', key, duration: 2 });
      }
    }).catch(() => {
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }

  useEffect(() => {
    getList()
  }, [])

  const deleteSurfSpotGeo = (id) => {
    confirm({
      title: '确定要删除该浪点地理分类吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios(servicePath.deleteSurfSpotGeo + '/' + id).then(res => {
          message.success('删除成功')
          getList()
        })
      },
      onCancel() {
        message.info('取消删除')
      },
    });
  }

  return (
    <div>
      <List
        header={
          <Row className="list-div">
            <Col span={3}><b>ID</b></Col>
            <Col span={4}><b>区域</b></Col>
            <Col span={4}><b>省份</b></Col>
            <Col span={4}><b>经度</b></Col>
            <Col span={4}><b>纬度</b></Col>
            <Col span={5}><b>国家</b></Col>
            <Col span={6}><b>操作</b></Col>
          </Row>
        }
        bordered
        dataSource={list}
        renderItem={item => (
          <List.Item>
            <Row className="list-div">
              <Col span={3}>{item.id}</Col>
              <Col span={4}>{item.district}</Col>
              <Col span={4}>{item.province}</Col>
              <Col span={4}>{item.longitude}</Col>
              <Col span={4}>{item.latitude}</Col>
              <Col span={5}>{item.country}</Col>
              <Col span={6}>
                <Button type="primary" onClick={() => props.history.push('/surfspotgeo/edit/' + item.id)}>修改</Button>&nbsp;
                <Button onClick={() => deleteSurfSpotGeo(item.id)}>删除</Button>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </div>
  )
}

export default SurfSpotGeoList